export default __webpack_public_path__ + "static/media/766.fce29607.png";